import { render, staticRenderFns } from "./c_home_group.vue?vue&type=template&id=04d5da31&scoped=true"
import script from "./c_home_group.vue?vue&type=script&lang=js"
export * from "./c_home_group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d5da31",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chillzon/Documents/projects/crmeb_view/mer_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04d5da31')) {
      api.createRecord('04d5da31', component.options)
    } else {
      api.reload('04d5da31', component.options)
    }
    module.hot.accept("./c_home_group.vue?vue&type=template&id=04d5da31&scoped=true", function () {
      api.rerender('04d5da31', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobileConfig/c_home_group.vue"
export default component.exports